module.exports = __webpack_public_path__ + "static/img/toCheck.4f1e42a.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/toCheck.png
// module id = hCwc
// module chunks = 21